/**
 * The lobby's What's new dot. The mark is the newest entry's date and change count, which tools/changelog-page.ts
 * inlines from changelog.json at build time, so the lobby never fetches the list. The changelog page records a
 * viewing as it loads, whichever link opened it, and the lobby hears of that through the storage event the write
 * raises in its tab.
 */
import { loadString, saveString } from './LocalStorage';

const SEEN_KEY = 'changelogSeen';

/** Whether the changelog changed since the player last opened it. A first visit only records the mark: to a new
 *  player everything is new, so the dot would just nag. With storage blocked the dot never shows. */
export function hasUnseenChanges(): boolean {
  const mark = __CHANGELOG_MARK__;
  if (mark === null) return false;
  const seen = loadString(SEEN_KEY);
  if (seen === null) {
    saveString(SEEN_KEY, mark);
    return false;
  }
  return seen !== mark;
}

/** Records the changelog as seen; the changelog page calls it as it loads. */
export function markChangelogSeen(): void {
  if (__CHANGELOG_MARK__ !== null) saveString(SEEN_KEY, __CHANGELOG_MARK__);
}

/** Calls back with whether the dot should show when another document writes the mark: the changelog page as it
 *  loads, or a second lobby tab's first visit. Returns the function that stops watching. */
export function watchUnseenChanges(onChange: (unseen: boolean) => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key === SEEN_KEY) onChange(hasUnseenChanges());
  };
  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
}
